import _ from 'underscore';
import { mapGetters, mapMutations } from 'vuex';

const fieldStateMixin = {
  computed: {
    resourceId() {
      return this.resource ? this.resource.id : null;
    },
    value: {
      set(value) {
        this.storeFieldValue({
          field: this.field,
          value: value,
          resourceId: this.resourceId
        });

        this.updateConditionalVisibility({
          field: this.field,
          resourceId: this.resourceId
        });
      },
      get() {
        return this.fieldValue(this.field, this.resourceId);
      }
    },
    ...mapGetters('entryForm', ['fieldValue'])
  },
  methods: {
    ...mapMutations('entryForm', ['storeFieldValue'])
  },
  created() {
    this.$store.dispatch('entryForm/updateConditionalVisibility', {
      field: this.field,
      resourceId: this.resourceId
    });

    // Avoid updating conditional visibility too often, wait for the user to finish inputing a value.
    this.updateConditionalVisibility = _.debounce(payload => {
      this.$store.dispatch('entryForm/updateConditionalVisibility', payload);
    }, 500);
  }
};

export default fieldStateMixin;
